import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { router } from '@/app/router'
import { initUtmPassthrough } from '@/lib/utm-passthrough'
import '@/styles/globals.css'

initUtmPassthrough()

const el = document.getElementById('root')
if (!el) throw new Error('Root element #root not found')

/*
 * Every route ships prerendered HTML, and `createRoot` replaces it on the
 * first render. Rendering before the route's code is in meant replacing a
 * finished page with a blank Suspense fallback for a moment: the white flash
 * on every page load. So wait for the router's first loaders (they fetch the
 * route's code) and replace the page with the same page. A slow network gets
 * the old behaviour after a few seconds rather than nothing at all.
 */
const ready = new Promise<void>((resolve) => {
  if (router.state.initialized) return resolve()
  const stop = router.subscribe((state) => {
    if (state.initialized) {
      stop()
      resolve()
    }
  })
})
const timeout = new Promise<void>((resolve) => setTimeout(resolve, 4000))

void Promise.race([ready, timeout]).then(() => {
  createRoot(el).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  )
})
